import React, { FC, useEffect, useState } from "react";
import { Col, List, Radio, Row, Space, Tag, Typography } from "antd";
import { openNotificationWithIcon } from "helpers/OpenNotificationWithIcon";
import { getPackageList } from "apps/CustomerPanel/Ad/Services";
import GeneralLoadingSpinner from "apps/Common/GeneralLoadingSpinner";
import { MazakaButton } from "apps/Common/MazakaButton";
import PackageItem from "./PackageItem";
import DopingListItem from "./DopingListItem";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import { handleSelectedPackageDoping } from "apps/CustomerPanel/Ad/ClientSideStates";
import { getUserPackage } from "apps/CustomerPanel/Profile/Services";
import dayjs from "dayjs";
import { useSearchParams } from "react-router-dom";
import PriceFormatter from "apps/Common/PriceFormatter";
import PageTitle from "apps/Common/PageTitle";
import { Helmet } from "react-helmet-async";

interface PackageIndexProps {
  setCurrentStep?: any;
  pageType?:string
}

const PackageListItem: FC<PackageIndexProps> = ({ setCurrentStep,pageType }) => {
  const { Text } = Typography;
  const [selectedPlan, setSelectedPlan] = useState<string>("");
  const [packageList, setPackageList] = useState<any>([]);
  const {adType} = useSelector((state:RootState)=>state.ad)
  const [isLoading, setIsLoading] = useState(false);
  const [isShowDopingList, setIsShowDopingList] = useState(false);
  const { selectedPackages } = useSelector((state: RootState) => state.ad);
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const advertId = searchParams.get("id");

  const handleChange = (e: any) => {
    setSelectedPlan(e.target.value);
  };

  const getPackages = async () => {
    setIsLoading(true);
    try {
      const response: any = await getPackageList();
      if (response?.data) {
        console.log("response", response.data);
        setPackageList([...response.data]);
      }
    } catch (error: any) {
      openNotificationWithIcon("default", error?.messge);
      console.log("Somethings wrong during getting packages  ", error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    managementUserPackages();
  }, []);

  //burada paket kullanılmış mı diye bir kontrol ekliyorum !!!!!
 const managementUserPackages = async () => {
  setIsLoading(true);
  try {
    const response: any = await getUserPackage();
    console.log("res", response.data);

    if (
      Array.isArray(response?.data) &&
      response.data.length > 0 &&
      response.data.some((item: any) => item.remainingRight > 0)
    ) {
      const userPackages = response.data.map((item: any) => ({
        ...item,
        inUser: true,
      }));
      setPackageList(userPackages);

      const packages = { ...selectedPackages };
      packages["package"] = userPackages[0].package;
      packages["advertId"] = advertId;

      dispatch(handleSelectedPackageDoping({ data: packages }));
    } else {
      getPackages();
    }
  } catch (error: any) {
    openNotificationWithIcon("default", error?.message);
    console.error("Error while getting user packages:", error);
  } finally {
    setIsLoading(false);
  }
};
  useEffect(() => {
    setSearchParams((prev) => {
      const newParams = new URLSearchParams(prev);
      newParams.set("currentStep", adType === "realState" ? "6" : "7");
      return newParams;
    });
  }, []);

  return (
    <Col xs={24} className={`!px-0 xl:!px-16 ${pageType==="advert"?"mt-4":""}`}>
      <Helmet>
          <title className="capitalize">{"Paketini Seç"}</title>
        </Helmet>
      <Radio.Group
        className="w-full"
        id="plan-group-item"
        onChange={handleChange}
        value={selectedPlan}
      >
        <Row gutter={[0, 40]} className="!px-0 xl:px-16">
          {
            pageType==="advert"&&
            <Col xs={24}>
                <Row gutter={[20, 20]}>
                    <Col xs={24}>
                      <Row>
                        <Col xs={24} className="!flex justify-center">
                          <Text className="!text-xl !font-bold !text-[#c55353]">
                            Daha fazla alıcıya ulaşmak ister misiniz?
                          </Text>
                        </Col>
                        <Col xs={24} className="!flex justify-center">
                          <Space>
                            
                            <Text className="!text-xl  !text-[#666666]">
                              ilanınızın 73* kata kadar daha fazla
                              görüntülenmesini sağlayın
                            </Text>
                          </Space>
                        </Col>
                      </Row>
                    </Col>
                    <Col span={24} className="!flex justify-center">
                      <Text className="!text-lg !font-bold !text-[#5e7a93]">
                        Sizin İçin Seçtiklerimiz
                      </Text>
                    </Col>
                 
                   
                  </Row>
            
            </Col>
          }
          {!isShowDopingList ? (
            <>
              <Col xs={24}>
                <Row gutter={[0, 20]}>
                  <Col className="!flex justify-center" xs={24}>
                  <PageTitle
                  title={packageList?.length > 0 ? "Mevcut Paketler" : "Paket Bulunamadı"}
                  />
                    
                  </Col>
                  <Col xs={24}>
                    {isLoading ? (
                      <>
                        <GeneralLoadingSpinner />
                      </>
                    ) : (
                      <Row gutter={[0, 20]}>
                        {packageList.length === 1&&packageList?.some((item:any)=>item.inUser) ? (
                          <>
                            <Col xs={24}>
                              <List
                                loading={isLoading}
                                dataSource={packageList}
                                bordered
                                renderItem={(item: any) => (
                                  <List.Item>
                                    <List.Item.Meta
                                      title={
                                        <Text className="!font-bold !text-2xl">
                                          {item?.package?.name ||item?.name|| ""}
                                        </Text>
                                      }
                                      description={
                                        <div className="!mt-2 ">
                                          <div className="!my-2">
                                            <div>
                                              <span>
                                                <Tag
                                                  className="!bg-blue-400"
                                                  color="primary"
                                                >
                                                  {" "}
                                                  Toplam Haklarınız:
                                                  {item.totalRight}
                                                </Tag>
                                              </span>
                                              <span>
                                                <Tag className="!bg-yellow-400">
                                                  {" "}
                                                  Kalan Haklarınız :
                                                  {item.remainingRight}
                                                </Tag>
                                              </span>
                                            </div>
                                          </div>
                                          <div className="!my-2">
                                            <p className="!text-black !font-bold">
                                              Baslangıç:
                                              <span>
                                                {dayjs(item.startDate).format(
                                                  "DD.MM.YYYY"
                                                )}
                                              </span>
                                            </p>
                                            <p className="!text-black !font-bold">
                                              Bitiş:
                                              {dayjs(item.endDate).format(
                                                "DD.MM.YYYY"
                                              )}
                                            </p>
                                          </div>
                                          <div>
                                            <Text className="!text-sm !text-gray-400">
                                              {item?.package?.description}
                                            </Text>
                                          </div>
                                        </div>
                                      }
                                    />
                                    <div className="!flex-col items-center justify-center !h-full">
                                      <p className="pt-2 tracking-wide">
                                        <span className="text-3xl font-semibold">
                                          <div>
                                            {item?.package?.priceWithDiscount >
                                              0 &&
                                            item?.package?.priceWithDiscount !==
                                              item?.price ? (
                                              <>
                                              
                                                <div>
                                                  <Text
                                                    className={`text-4xl !text-black`}
                                                  >
                                                    <PriceFormatter inputPrice={item?.package
                                                        ?.priceWithDiscount} />
                                                  
                                                  </Text>
                                                </div>
                                              </>
                                            ) : (
                                              <Text
                                                className={`text-4xl font-bold !text-black`}
                                              >
                                                <PriceFormatter inputPrice={item?.package?.price} />
                                          
                                              </Text>
                                            )}
                                          </div>
                                        </span>
                                      </p>
                                    </div>
                                  </List.Item>
                                )}
                              />
                            </Col>
                          </>
                        ) : (
                          <>
                            {packageList.map((option: any) => {
                              const isSelected = selectedPlan === option.id;
                              console.log("isSelected", isSelected);
                              return (
                                <>
                                  <PackageItem
                                    option={option}
                                    isSelected={isSelected}
                                  />
                                </>
                              );
                            })}
                          </>
                        )}

                        <Col xs={24}>
                          <MazakaButton
                            className="!p-4 !bg-[#FFC502] !text-black"
                            onClick={() => {
                              if (selectedPlan) {
                                const findPackage = packageList.find(
                                  (item: any) => {
                                    if (item?.Id) {
                                      console.log("item", item);
                                      return item.Id === selectedPlan;
                                    }
                                    return item.id === selectedPlan;
                                  }
                                );
                                console.log("findPackage", findPackage);
                                if (findPackage) {
                                  const data = { ...selectedPackages };
                                  console.log("findPackage", data);
                                  if (findPackage?.packageId) {
                                    data["package"] = findPackage.package;
                                    data["advertId"] = advertId;
                                  } else {
                                    data["package"] = findPackage;
                                    data["advertId"] = advertId;
                                  }

                                  
                                  dispatch(
                                    handleSelectedPackageDoping({ data })
                                  );
                                  if(pageType==="advert")
                                  {
                                   setCurrentStep(adType==="realState"?7:8)
                                  }
                                  else{

                                    setIsShowDopingList(true);
                                  }
                                } else {
                                  openNotificationWithIcon(
                                    "error",
                                    "Paket Bulunmadı"
                                  );
                                }
                              } else if (packageList?.length === 1) {
                                setIsShowDopingList(true);
                              } else {
                                openNotificationWithIcon(
                                  "error",
                                  "Lüften bir paket seçiniz"
                                );
                              }
                            }}
                          >
                            Kaydet ve Devam Et
                          </MazakaButton>
                        </Col>
                      </Row>
                    )}
                  </Col>
                </Row>
              </Col>
            </>
          ) : (
            <>
              <DopingListItem
                type="ad"
                setCurrentStep={setCurrentStep}
                setIsShowDopingLis={setIsShowDopingList}
                // selectedPackage={selectedPlan}
              />
            </>
          )}
        </Row>
      </Radio.Group>
    </Col>
  );
};

export default PackageListItem;
